<template>
  <v-content>
    <v-row no-gutters>
      <v-col cols="12">
        <v-flex class="pb-2 ml-0">
          <v-alert dense color="primary" class="text-left" text border="left"
            >PERFIL DE VENDAS</v-alert
          >
        </v-flex>
      </v-col>
    </v-row>
    <v-card>
      <v-row no-gutters>
        <v-col cols="4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Pesquisar"
            filled
            dense
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="text-left" cols="4">
          <v-btn @click="novo()" color="topEnviados" dark>
            <v-icon>mdi-plus</v-icon>Novo
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading_table"
        :footerProps="footerProps"
        loading-text="Carregando... Aguarde"
        dense
        :search="search"
        no-data-text="Nenhum resultado encontrado!"
        no-results-text="Nenhum resultado encontrado!"
        class="elevation-2"
      >
        <!--<template class="text-right" v-slot:item.chk_ativo="{ item }">
          <v-switch
            class="text-rigth"
            color="botao_sucesso"
            :label="`${checkStatus(item.chk_ativo)}`"
            @change="mudarStatus(item.id, item.chk_ativo)"
            v-model="item.chk_ativo == 1 ? true : false"
            value="item.chk_ativo"
          ></v-switch>
        </template>-->
        <template class="text-right" v-slot:item.copiar="{ item }">
          <v-btn @click="copyText(item.link)" small>
            <v-icon left>
              mdi-link
            </v-icon>
            Copiar Link
          </v-btn>
        </template>
        <template v-slot:item.ativo="{ item }">
          <v-switch
            dense
            color="green"
            :label="`${checkStatus(item.ativo)}`"
            @change="mudarStatus(item.id, item.ativo, 'ativo')"
            v-model="item.ativo"
            value
          ></v-switch>
        </template>
        <template v-slot:item.excluir="{ item }">
          <v-icon
            color="error"
            class="mr-2"
            v-show="$can('admin.loja|perfil.delete')"
            @click="deletePerfil(item)"
            >delete</v-icon
          >
        </template>
        <template v-slot:item.editar="{ item }">
          <v-icon small color="btBlue" class="mr-2" @click="editPerfil(item)"
            >edit</v-icon
          >
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogCadastro" persistent max-width="70%">
      <v-card>
        <v-card-title class>
          <span v-if="cadastro">Cadastro Perfil Vendas</span>
          <span v-if="cadastro == false">Editar Perfil Vendas</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-container>
              <v-row>
                <v-col cols="12" xl="5" lg="5" md="5" sm="5" xs="12">
                  <v-text-field
                    v-model="perfil.descricao"
                    label="Nome Perfil"
                    filled
                    chips
                    dense
                    @keypress="tamanhoReduzida"
                    clearable
                    counter="50"
                    required
                  ></v-text-field>
                </v-col>

                <v-col
                  align="left"
                  cols="12"
                  xl="5"
                  lg="5"
                  md="5"
                  sm="5"
                  xs="12"
                >
                  <v-select
                    v-model="perfil.categorias"
                    :items="itemsCategoria"
                    label="Categoria"
                    item-text="descricao"
                    item-value="id"
                    class="text-md-left"
                    clearable
                    dense
                    multiple
                    filled
                    required
                  ></v-select>
                </v-col>
              
              
              </v-row>
              <v-row>
            
                <v-col cols="12" xl="2" lg="5" md="6" sm="6" xs="12">
                <v-text-field
                    v-model="perfil.link_anuncio"
                    label="Link Anúncio"
                    filled
                    chips
                    dense
                    
                    clearable
                    counter="50"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xl="2" lg="2" md="2" sm="2" xs="12">
                  <v-checkbox
                    v-model="perfil.tipo"
                    label="Box | Cesta | Kit"
                    required
                    @change="changeTipo()"
                    false-value="N"
                    true-value="B"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="error" @click="dialogCadastro = false">
              <v-icon>mdi-close</v-icon>Fechar
            </v-btn>
          </v-col>
          <v-col cols="12" md="6" lg="6">
            <v-btn
              v-if="cadastro"
              color="success"
              class="mr-4"
              @click="gravar()"
            >
              <v-icon>mdi-check</v-icon>Gravar
            </v-btn>
            <v-btn
              v-if="cadastro == false"
              color="success"
              class="mr-4"
              @click="gravarEdicao()"
            >
              <v-icon>mdi-check</v-icon>Editar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-dialog v-model="dialogCancel" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text>Deseja excluir esse perfil?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              class="white--text"
              @click="dialogCancel = false"
              >Não</v-btn
            >
            <v-btn
              color="green darken-1"
              class="white--text"
              @click="deleta(selItem)"
              >Sim</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-snackbar
      :timeout="2000"
      :color="sucesso"
      :multi-line="multiline"
      :vertical="'vertical'"
      v-model="snackbar"
    >
      {{ textSnack }}
    </v-snackbar>
  </v-content>
</template>

<script>
var moment = require("moment");
import { mask } from "vue-the-mask";
function splitNum(num) {
  return String(num)
    .split("")
    .map(Number);
}
const auth = {
  headers: {
    Authorization: "bearer " + window.sessionStorage.getItem("token"),
  },
};

export default {
  directives: { mask },
  props: {
    source: String,
  },
  mounted() {
    //this.buscaNotas();
    // this.gerarQrcode();
    this.lista();

    //  this.linkCardapio();
  },

  data: () => ({
    dialogCancel: false,
    itemsCategoria: [],
    loadingbt: false,
    multiline: true,
    textSnack: "",
    snackbar: false,
    cadastro: true,
    dialogCadastro: false,
    itensPorPagina: 25,
    items: [],
    itemsProdutosSgt: [],
    itemsProdutosSgtVinculados: [],
    search: "",
    searchVinculados: "",
    loading_table: false,
    search: "",
    sucesso: "sucesso",
    selItem: "",
    perfil: { descricao: "", link_anuncio:"", tipo: "N", categorias: [] },

    footerProps: { "items-per-page-options": [30, 50, 100] },
    headers: [
      {
        text: "Nome do Perfil",
        align: "left",
        sortable: true,
        value: "descricao",
      },

      {
        text: "Link de Vendas",
        align: "left",
        sortable: true,
        value: "link",
      },
      {
        text: "",
        align: "left",
        sortable: false,
        value: "copiar",
      },
      {
        text: "Editar",
        align: "left",
        sortable: false,
        value: "editar",
      },

      { text: "Status", value: "ativo", sortable: false },
      {
        text: "Exluir",
        align: "left",
        sortable: false,
        value: "excluir",
      },
    ],
  }),

  methods: {
    editPerfil(item) {
      this.categorias();

      this.cadastro = false;
      this.dialogCadastro = true;
      this.perfil.descricao = item.descricao;
      this.perfil.id = item.id;
      setTimeout(() => {
        // let numeros = splitNum(item.categorias);
        //let cats = numeros.map(Number);
        this.perfil.categorias = eval("[" + item.categorias + "]");
      }, 1000);
    },
    deleta() {
      axios
        .post(`/perfil_vendas/deleta`, { id: this.selItem })
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbarError = true;
          } else {
            this.snackbar = true;
            this.textSnack = response.data.msg;
            this.dialogCancel = false;
            this.lista();
          }
        });
    },
    deletePerfil(item) {
      console.log(item);
      this.selItem = item.id;

      this.dialogCancel = true;
    },
    tamanhoReduzida(ev) {
      if (ev.target.value.length === 50) {
        event.preventDefault();
        return;
      }
    },
    categorias() {
      axios.get(`/categoria/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.itemsCategoria = response.data;
        }
      });
    },
    mudarStatus(id, status) {
      axios
        .post(`/perfil_vendas/status`, { id: id, status: status })
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.snackbar = true;
            this.textSnack = "Status alterado!";
            this.lista();
          }
        });
    },
    gravar() {
      axios.post(`/perfil_vendas`, this.perfil).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.snackbar = true;
          this.textSnack = "Gravado com sucesso!";
          this.lista();
          this.dialogCadastro = false;
        }
      });
    },
    gravarEdicao() {
      axios.post(`/perfil_vendas/editar`, this.perfil).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.snackbar = true;
          this.textSnack = "Gravado com sucesso!";
          this.lista();
          this.dialogCadastro = false;
        }
      });
    },
    checkStatus(valor) {
      if (valor) {
        return "ativo";
      } else {
        return "desativado";
      }
    },
    copyText(link) {
      navigator.clipboard.writeText(link);

      this.snackbar = true;
      this.textSnack = "Link copiado";
    },
    linkCardapio() {
      axios.get(`/config/link_cardapio`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.link_cardapio = response.data.url;

          // console.log(response.data);
        }
      });
    },
    lista() {
      axios.get(`/perfil_vendas/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.items = response.data;
          // console.log(response.data);
        }
      });
    },
    mudarValor(campo, valor) {
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      /*  if(campo =="tempo_entrega"){
        data:{tempo_entrega:valor}
      }*/
      var formData = new FormData();
      formData.append(campo, valor);
      axios
        .post(`/config`, formData, config)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaProdutosSgt();
            this.snackbar = true;
            this.textSnack = response.data.msg;
            this.categoria.descricao = "";
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
    },
    novo() {
      this.cadastro = true;
      this.dialogCadastro = true;
      this.categorias();
      this.perfil.descricao = "";
      this.perfil.categorias = [];
      this.perfil.tipo = "N";
    },
  },
};
</script>
<style scoped>
.cancelada {
  color: red;
}
</style>
